import { FC, useCallback, useEffect, useRef } from 'react';
import { useLeafletContext } from '@react-leaflet/core';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import * as L from 'leaflet';
import { useFieldSlice } from 'app/containers/Field/slice';
import { useDispatch, useSelector } from 'react-redux';
import useAddPolygonToLayerGroup from './useAddPolygonToLayerGroup';
import { selectSingleFieldOnMap } from 'app/containers/Map/slice/selectors';

interface IProps {}

const GeomanEditPolygon: FC<IProps> = () => {
  const leafletContext = useLeafletContext();
  const { actions: fieldActions } = useFieldSlice();
  const dispatch = useDispatch();

  const field = useSelector(selectSingleFieldOnMap);

  const geomanLayerRef = useRef<any>(null);
  const leafletContainerRef = useRef<any>(null);

  const onChange = useCallback(() => {
    if (geomanLayerRef.current) {
      const polygon = Object.values(geomanLayerRef.current._layers)[0] as any;
      if (polygon) {
        dispatch(
          fieldActions.setEditFieldLatLngs(
            // Deep clone lat lngs - otherwise geoman crashes
            JSON.parse(JSON.stringify(polygon.getLatLngs())),
          ),
        );
      }
    }
  }, [dispatch, fieldActions]);

  useEffect(() => {
    const leafletContainer = (leafletContext.layerContainer ||
      leafletContext.map) as any;
    leafletContainerRef.current = leafletContainer;

    leafletContainer.pm.addControls({
      position: 'topright',
      editMode: true,

      drawPolygon: false,
      drawMarker: false,
      drawCircleMarker: false,
      drawPolyline: false,
      drawRectangle: false,
      drawCircle: false,
      drawText: false,
      removalMode: false,
    });

    const geomanDrawPolygonsLayer = L.layerGroup() as any;
    geomanDrawPolygonsLayer.addTo(leafletContainer);

    geomanLayerRef.current = geomanDrawPolygonsLayer;

    leafletContainer.pm.setGlobalOptions({
      pmIgnore: false,
      layerGroup: geomanDrawPolygonsLayer,
      allowSelfIntersection: false,
    });

    return () => {
      leafletContainer.pm.removeControls();
      leafletContainer.pm.setGlobalOptions({ pmIgnore: true });
    };
  }, [leafletContext]);

  useAddPolygonToLayerGroup({
    geomanLayerRef,
    field,
    onChange,
  });

  return null;
};

export default GeomanEditPolygon;
